import _HTTPS from '../plugins/axios/index'
export default {
  // 首页
  async GetPCHome({ commit }, params) {
    return await _HTTPS.httpPost('/api/AppService/GetPCHome', params)
  },
  // 获取城市
  async OpeningCity({ commit }, params) {
    return await _HTTPS.httpPost('/api/Marketing/OpeningCity', params)
  },
  // 注册
  async Register({ commit }, params) {
    return await _HTTPS.httpPost('/api/Token/Register', params)
  },
  // 获取城市
  async GetCountries({ commit }, params) {
    return await _HTTPS.httpPost('/api/Token/GetCountries', params)
  },
  // 获取验证码
  async GetVerificationCode({ commit }, params) {
    return await _HTTPS.httpPost('/api/Token/GetVerificationCode', params)
  },
  // 发送邮箱验证码
  async VerCodeSendEmail({ commit }, params) {
    return await _HTTPS.httpPost('/api/Token/VerCodeSendEmail', params)
  },
  // 手机号找回密码
  async RetrievePassword({ commit }, params) {
    return await _HTTPS.httpPost('/api/Token/RetrievePassword', params)
  },
  // 登录
  async Login({ commit }, params) {
    return await _HTTPS.httpPost('/api/Token/AppLogin', params)
  },
  // 获取用户信息接口
  async GetCustomerInfo({ commit }, params) {
    return await _HTTPS.httpPost('/api/Customer/GetCustomerInfo', params)
  },
  // 获取首页的购物车商品数量
  async GetCartNum({ commit }, params) {
    return await _HTTPS.httpPost('/api/ShoppingCart/GetCartNum', params)
  },
  // 获取电子券
  async GetCashVoucher({ commit }, params) {
    return await _HTTPS.httpPost('/api/Customer/GetCashVoucher', params)
  },
  // 获取购物车商品
  async GetCartPros({ commit }, params) {
    return await _HTTPS.httpPost('/api/ShoppingCart/GetCartPros', params)
  },
  // 获取网站所有品类的接口
  async GetCatasPC({ commit }, params) {
    return await _HTTPS.httpPost('/api/product/GetCatasPC', params)
  },
  // 关键词搜索接口
  async IntelligenceSearch({ commit }, params) {
    return await _HTTPS.httpPostNew('/api/Search/InputTriggered', params)
  },
  // 获取商品搜索筛选信息
  async GetProductSearchFilter({ commit }, params) {
    return await _HTTPS.httpPostNew('/api/product/GetProductSearchFilter', params)
  },
  // 获取搜索商品数据
  async GetSearchList({ commit }, params) {
    return await _HTTPS.httpPostNew('/api/v1.1/Search/SearchProduct', params)
  },
  // 品类商品列表，专区商品列表，特色属性商品列表，亚洲商品列表
  async GetProList({ commit }, params) {
    return await _HTTPS.httpPost('/api/Product/GetProList', params)
  },
  // 获取分类商品列表页的广告和导航栏
  async GetCataAdlist({ commit }, params) {
    return await _HTTPS.httpPost('/api/Product/GetCataAdlist', params)
  },
  // 获取优惠促销的商品信息
  async GetPromotionListPC({ commit }, params) {
    return await _HTTPS.httpPost('/api/Product/GetPromotionList', params)
  },
  // 获取商品详情页
  async GetDetailByProID({ commit }, params) {
    return await _HTTPS.httpPost('/api/Product/GetDetailByProID', params)
  },
  // 购物车广告和商品接口
  async GetAdvertisingSpace({ commit }, params) {
    return await _HTTPS.httpPost('/api/Marketing/GetAdvertisingSpace', params)
  },
  // 获取购物车商品以及头部商品列表
  async GetCartPros({ commit }, params) {
    return await _HTTPS.httpPost('/api/ShoppingCart/GetCartPros', params)
  },
  // 获取遗忘商品和安心果蔬的接口
  async GetForgetPro({ commit }, params) {
    return await _HTTPS.httpPost('/api/ShoppingCart/GetForgetPro', params)
  },
  // 推荐相似商品的接口
  async GetGoodLikePros({ commit }, params) {
    return await _HTTPS.httpPost('/api/Product/GetGoodLikePros', params)
  },
  // 修改购物车中的商品的选中状态（单选）
  async ChangeSelected({ commit }, params) {
    return await _HTTPS.httpPost('/api/ShoppingCart/ChangeSelected', params)
  },
  // 选中或者取消购物车所有商品
  async ChangeAllSelected({ commit }, params) {
    return await _HTTPS.httpPost('/api/ShoppingCart/ChangeAllSelected', params)
  },
  // 设置到货提醒
  async SetArrivalNotice({ commit }, params) {
    return await _HTTPS.httpPost('/api/Product/SetArrivalNotice', params)
  },
  // 添加喜欢收藏
  async SumimtShouCang({ commit }, params) {
    return await _HTTPS.httpPost('/api/Product/SumimtShouCang', params)
  },
  // 删除喜欢收藏的商品
  async DelShouCang({ commit }, params) {
    return await _HTTPS.httpPost('/api/Customer/DelShouCang', params)
  },
  // 注册页背景图
  async GetRegisterPic({ commit }, params) {
    return await _HTTPS.httpPost('/api/AppService/GetRegisterPic', params)
  },
  // 添加商品到购物车
  async AddToCart({ commit }, params) {
    return await _HTTPS.httpPost('/api/ShoppingCart/AddToCart', params)
  },
  // 操作购物车内的商品 增加/减少/删除/修改特定数量
  async ChangeCartNum({ commit }, params) {
    return await _HTTPS.httpPost('/api/ShoppingCart/ChangeCartNum', params)
  },
  // 删除购物车无效商品
  async DeleteShopCartProducts({ commit }, params) {
    return await _HTTPS.httpPost('/api/ShoppingCart/DeleteShopCartProducts', params)
  },
  // 获取订单草稿页面信息
  async GetDraftOrder({ commit }, params) {
    return await _HTTPS.httpPost('/api/Order/GetDraftOrder', params)
  },
  // 更换地址获取订单信息
  async GetCarryDateList({ commit }, params) {
    return await _HTTPS.httpPost('/api/Order/GetCarryDateList', params)
  },
  // 获取省份信息列表包含城市和区域信息的接口
  async GetProvinceAllList({ commit }, params) {
    return await _HTTPS.httpPost('/api/Order/GetProvinceAllList', params)
  },
  // 获取所有收货地址
  async GetAddressList({ commit }, params) {
    return await _HTTPS.httpPost('/api/Order/GetAddressList', params)
  },
  // 新增或修改收货人信息的接口
  async SaveOrUpdateCon({ commit }, params) {
    return await _HTTPS.httpPost('/api/Order/SaveOrUpdateCon', params)
  },
  // 删除地址
  async DeleteCon({ commit }, params) {
    return await _HTTPS.httpPost('/api/Order/DeleteCon', params)
  },
  // 获取常购清单的接口
  async GetRegularPurchaseProducts({ commit }, params) {
    return await _HTTPS.httpPost('/api/Marketing/GetRegularPurchaseProducts', params)
  },
  // 到货提醒
  async GetArrivalNotice({ commit }, params) {
    return await _HTTPS.httpPost('/api/Customer/GetArrivalNotice', params)
  },
  // 获取收藏的商品
  async GetCollectProductList({ commit }, params) {
    return await _HTTPS.httpPost('/api/Customer/GetCollectProductList', params)
  },
  // 删除到货提醒的接口
  async DeleteArrivalNotice({ commit }, params) {
    return await _HTTPS.httpPost('/api/Customer/DeleteArrivalNotice', params)
  },
  // 修改邮箱
  async ChangeEmail({ commit }, params) {
    return await _HTTPS.httpPost('/api/Customer/ChangeEmail', params)
  },
  // 修改密码
  async ChangePassword({ commit }, params) {
    return await _HTTPS.httpPost('/api/Customer/ChangePassword', params)
  },
  // 获取站内信类型
  async GetNoticeType({ commit }, params) {
    return await _HTTPS.httpPost('/api/Customer/GetNoticeType', params)
  },
  // 获取站内信的接口
  async GetWebsiteNotice({ commit }, params) {
    return await _HTTPS.httpPost('/api/Customer/GetWebsiteNotice', params)
  },
  // 阅读站内信
  async ReadingNotice({ commit }, params) {
    return await _HTTPS.httpPost('/api/Customer/ReadingNotice', params)
  },
  // 获取赢盘卡
  async GetRechargeableCard({ commit }, params) {
    return await _HTTPS.httpPost('/api/Order/GetRechargeableCard', params)
  },
  // 激活赢盘卡接口
  async ActiveCard({ commit }, params) {
    return await _HTTPS.httpPost('/api/Order/ActiveCard', params)
  },
  // 获取账户明细的接口
  async GetBalanceDetailed({ commit }, params) {
    return await _HTTPS.httpPost('/api/Customer/GetBalanceDetailed', params)
  },
  // 获取积分明细
  async GetPointsDetailed({ commit }, params) {
    return await _HTTPS.httpPost('/api/Customer/GetPointsDetailed', params)
  },
  // 获取积分兑换记录
  async GetRedeCusRecords({ commit }, params) {
    return await _HTTPS.httpPost('/api/Customer/GetRedeCusRecords', params)
  },
  // 获取邀请好友页面的数据
  async GetRecomfriends({ commit }, params) {
    return await _HTTPS.httpPost('/api/Customer/GetRecomfriends', params)
  },
  // 邀请好友发送邮件
  async SendEmail({ commit }, params) {
    return await _HTTPS.httpPost('/api/Customer/SendEmail', params)
  },
  // 获取关于我们的菜单信息
  async GetAboutus({ commit }, params) {
    return await _HTTPS.httpPost('/api/Customer/GetAboutus', params)
  },
  // 获取关于我们的详情明细
  async GetAboutusDetails({ commit }, params) {
    return await _HTTPS.httpPost('/api/Customer/GetAboutusDetails', params)
  },
  // 生成随机数验证码图片
  async GetValidateImg({ commit }, params) {
    return await _HTTPS.httpPost('/api/Token/GetValidateImg', params)
  },
  // 提交验证码PC端
  async SubmitValidatePhone({ commit }, params) {
    return await _HTTPS.httpPost('/api/Token/SubmitValidatePhone', params)
  },
  // 修改用户信息
  async ModifyUserInformation({ commit }, params) {
    return await _HTTPS.httpPost('/api/Customer/ModifyUserInformation', params)
  },
  // 获取彩虹早餐
  async GetBreakList({ commit }, params) {
    return await _HTTPS.httpPost('/api/Product/GetBreakList', params)
  },
  // 获取彩虹早餐详情
  async GetBreakDetailByProID({ commit }, params) {
    return await _HTTPS.httpPost('/api/Product/GetBreakDetailByProID', params)
  },
  // 获取红酒首页
  async GetWineIndex({ commit }, params) {
    return await _HTTPS.httpPost('/api/Product/GetWineIndex', params)
  },
  // 获取红酒列表
  async GetWineList({ commit }, params) {
    return await _HTTPS.httpPost('/api/Product/GetWineList', params)
  },
  // 获取积分兑换商品
  async GetRedemptions({ commit }, params) {
    return await _HTTPS.httpPost('/api/Customer/GetRedemptions', params)
  },
  // 积分商品详情
  async GetRedemptionsInfo({ commit }, params) {
    return await _HTTPS.httpPost('/api/Customer/GetRedemptionsInfo', params)
  },
  // 每月营养商品查询
  async GetEperLifePros({ commit }, params) {
    return await _HTTPS.httpPost('/api/EperBoxProduct/GetEperLifePros', params)
  },
  //获取每月营养订单确认数据
  async GetDraftBoxOrder({ commit }, params) {
    return await _HTTPS.httpPost('/api/Order/GetDraftBoxOrder', params)
  },
  //获取所在省市数据
  async GetProvinceAllList({ commit }, params) {
    return await _HTTPS.httpPost('/api/Order/GetProvinceAllList', params)
  },
  //新增或修改收货人信息
  async SaveOrUpdateCon({ commit }, params) {
    return await _HTTPS.httpPost('/api/Order/SaveOrUpdateCon', params)
  },
  //每月营养费用运算
  async ShowBoxOrderAcc({ commit }, params) {
    return await _HTTPS.httpPost('/api/Order/ShowBoxOrderAcc', params)
  },

  //创建周期配订单
  async PlaceBoxOrder({ commit }, params) {
    return await _HTTPS.httpPost('/api/Order/PlaceBoxOrder', params)
  },

  // 积分兑换操作
  async IntegralProductExchange({ commit }, params) {
    return await _HTTPS.httpPost('/api/Customer/IntegralProductExchange', params)
  },
  //获取配送时间
  async GetCarryTimeList({ commit }, params) {
    return await _HTTPS.httpPost('/api/Order/GetCarryTimeList', params)
  },
  //验证优惠券
  async CheckCoupon({ commit }, params) {
    return await _HTTPS.httpPost('/api/Order/CheckCoupon', params)
  },
  //获取订单支付费用
  async GetDraftOrderMoney({ commit }, params) {
    return await _HTTPS.httpPost('/api/Order/GetDraftOrderMoney', params)
  },
  //创建订单
  async PlaceOrder({ commit }, params) {
    return await _HTTPS.httpPost('/api/Order/PlaceOrder', params)
  },
  // 设置默认快递地址
  async SetAddressDefault({ commit }, params) {
    return await _HTTPS.httpPost('/api/Order/SetAddressDefault', params)
  },
  // 设置默认快递地址
  async SetAddressDefault({ commit }, params) {
    return await _HTTPS.httpPost('/api/Order/SetAddressDefault', params)
  },
  // 获取历史订单
  async GetOrdersList({ commit }, params) {
    return await _HTTPS.httpPost('/api/Order/GetOrdersList', params)
  },
  // 申请或更新发票
  async AddOrUpdateInvoice({ commit }, params) {
    return await _HTTPS.httpPost('/api/Order/AddOrUpdateInvoice', params)
  },
  // 下载发票
  async DownInvoice({ commit }, params) {
    return await _HTTPS.httpPost('/api/Order/DownInvoice', params)
  },
  //获取已经开票列表
  async GetListInvoice({ commit }, params) {
    return await _HTTPS.httpPost('/api/Order/GetListInvoice', params)
  },
  // 获取订单明细
  async GetOrderDetail({ commit }, params) {
    return await _HTTPS.httpPost('/api/Order/GetOrderDetail', params)
  },
  // 微信登录检查用户有没有绑定账号
  async CheckUser({ commit }, params) {
    return await _HTTPS.httpPost('/api/token/CheckUser', params)
  },
  // 支付订单
  async Pay({ commit }, params) {
    return await _HTTPS.httpPost('/api/Order/Pay', params)
  },
  // 支付成功后获取订单信息
  async GetPaySuccessInfo({ commit }, params) {
    return await _HTTPS.httpPost('/api/Order/GetPaySuccessInfo', params)
  },
  // 获取在线充值金额种类信息
  async GetOnlineRecharge({ commit }, params) {
    return await _HTTPS.httpPost('/api/Order/GetOnlineRecharge', params)
  },
  // 创建充值订单
  async PlaceRechargeOrder({ commit }, params) {
    return await _HTTPS.httpPost('/api/Order/PlaceRechargeOrder', params)
  },
  // 验证订单是否已支付
  async CheckPayStatus({ commit }, params) {
    return await _HTTPS.httpPost('/api/Order/CheckPayStatus', params)
  },
  // 批量设置提醒商品
  async SettingProsTip({ commit }, params) {
    return await _HTTPS.httpPost('/api/Order/SettingProsTip', params)
  },
  // 获取eperbox商品数据
  async GetEperBoxPros({ commit }, params) {
    return await _HTTPS.httpPost('/api/EperBoxProduct/GetEperBoxPros', params)
  },
  // 获取指定品类的所有上级类别 （包含当前品类）适用于 面包屑 场景 如 商品详情页面
  async GetUpCata({ commit }, params) {
    return await _HTTPS.httpPost('/api/Product/GetUpCata', params)
  },

  // 获取指定品类的所有子类或所有同一级品类
  async GetSubCataSiblings({ commit }, params) {
    return await _HTTPS.httpPost('/api/Product/GetSubCataSiblings', params)
  },

  // 检查原密码
  async CheckPassword({ commit }, params) {
    return await _HTTPS.httpPost('/api/Customer/CheckPassword', params)
  },
  // 获取eu 数据
  async getEu({ commit }, params) {
    return await _HTTPS.httpPost('/api/Marketing/GetEuPage', params)
  },
  // 获取站内信数量

  async getLetter({ commit }, params) {
    return await _HTTPS.httpPost('/api/Customer/GetWebsiteNotice', params)
  },
   // 获取购物券
   async GetPreVoucherShow({ commit }, params) {
    return await _HTTPS.httpPost('/api/Promotion/getPreVoucherShow', params)
  },
  // 获取订餐类型
	async GetCateringEventType({commit}, params) {
		return await _HTTPS.httpPostNew('/api/Index/GetCateringEventType', params);
	},
  // 提交订餐信息
	async CateringAdd({commit}, params) {
		return await _HTTPS.httpPostNew('/api/Index/AddCatering', params);
	},
  // 查询多规格信息
	async ShowBindingProduct({commit}, params) {
		return await _HTTPS.httpPostNew('/api/Cart/ShowBindingProduct', params);
	},
  // 搜索结果页获取广告信息
  async GetSearchAd({ commit }, params) {
    return await _HTTPS.httpPostNew('/api/Ad/GetSearchAd', params)
  },
  // 取消订单
  async Addcancelorder({ commit }, params) {
    return await _HTTPS.httpPost('/api/Order/addcancelorder', params)
  },
  // 获取meta 标签内容
  async GetMeta({ commit }, params) {
    return await _HTTPS.httpPost('/api/Product/GetSeoInfo', params)
  },
  // 查询多规格信息 列表
	async ShowBindingProductList({commit}, params) {
		return await _HTTPS.httpPostNew('/api/Cart/ShowBindingProductList', params);
	},
  // 首页注册成功数据
  async GetRegTeJiaPros({commit}, params) {
		return await _HTTPS.httpPost('/api/promotion/GetRegTeJiaPros', params);
	},
  // 获取领券信息
	async GetSecondOrderGifts({commit}, params) {
		return await _HTTPS.httpPost('/api/promotion/GetSecondOrderGifts', params);
	},
  // 优惠券列表
	async FindCashVoucherList({commit}, params) {
		return await _HTTPS.httpPostNew('/api/Order/FindCashVoucherList', params);
	},
  // 查询线上券关联商品
	async FindCashVoucherProductList({commit}, params) {
		return await _HTTPS.httpPostNew('/api/Coupon/FindCashVoucherProductList', params);
	},
  // 检查券商品是否可以加入购物车
	async CheckCashVoucherProductAddToCart({commit}, params) {
		return await _HTTPS.httpPostNew('/api/Cart/CheckCashVoucherProductAddToCart', params);
	},
  // 赠品加入购物车
	async AddGiftProductCart({commit}, params) {
		return await _HTTPS.httpPostNew('/api/Cart/Add', params);
	},
  // 特价专区页面专用接口
	async GetPromZoneProList({commit}, params) {
		return await _HTTPS.httpPost('/api/Product/GetPromZoneProList', params);
	},
  // 请求语言
	async GetLang({commit}, params) {
		return await _HTTPS.httpPostNew('/api/SettingData/Get', params);
	},
  // 检查版本
	async CheckVersion({commit}, params) {
		return await _HTTPS.httpPostNew('/api/SettingData/Check', params);
	},
  // 网站背景
	async GetPromBackGround({commit}, params) {
		return await _HTTPS.httpPost('/api/Marketing/GetPromBackGround', params);
	},
  // 删除购物车选中商品
	async DeleteCartSltPros({commit}, params) {
		return await _HTTPS.httpPost('/api/ShoppingCart/DeleteCartSltPros', params);
	},
  // 注册成功送券
  async GetOrientationProm({commit}, params) {
		return await _HTTPS.httpPost('/api/Promotion/GetOrientationProm', params);
	},
  //注册成功领券
  async GetOrientationPromVoucher({commit}, params) {
		return await _HTTPS.httpPost('/api/Promotion/GetOrientationPromVoucher', params);
	}
}



// WEBPACK FOOTER //
// ./src/store/actions.js